// import { addYears } from 'date-fns';
import { RuleProps } from 'types/application';
import { idNoValidation } from 'features/applicationPage/helpers';

export const SECT_TYPE = 'applicant-type-section';
export const SECT_FILER = 'filer-details';
export const SECT_APPLICANT = 'applicant-details';
export const SECT_ADDRESS = 'address-details';
export const ORGANISATION_DETAILS = 'organisation-details';

export const GENERAL_FIELDS = [
    {
        sectionID: SECT_APPLICANT,
        sectionName: 'Applicant Details',
        fieldList: [
            {
                id: 'id-type',
                apiID: 'IDTypeFVG',
                label: 'ID Type',
                type: 'dropdown',
                rule: {
                    // baseIds: [`${SECT_APPLICANT}-nationality`, `${SECT_TYPE}-applicant-type`],
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'idno',
                label: 'ID No.',
                type: 'text',
                rule: {
                    // baseIds: [`${SECT_APPLICANT}-id-type`, `${SECT_TYPE}-applicant-type`],
                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                        const idType = baseValues && (baseValues[`${SECT_APPLICANT}-id-type`] as string);
                        const result = idNoValidation(currentValue as string, idType);
                        return result;
                    },
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'salutaion',
                apiID: 'Salutation',
                label: 'Salutation',
                type: 'dropdown',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                },
                options: [{ optID: 'Dr', optLabel: 'Dr' }]
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text',
                // defaultValue: 'Alex Sim',
                rule: {
                    // baseIds: [`${SECT_TYPE}-applicant-type`],
                    required: true,
                    charLength: 66,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'mobile-no',
                label: 'Contact No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    rule: {
                        baseIds: [`${SECT_APPLICANT}-mobile-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? /^[89][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'other-mobile-no',
                label: 'Other Contact No.',
                type: 'combo',
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    rule: {
                        baseIds: [`${SECT_APPLICANT}-mobile-no-country-code`],
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? /^[689][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'email',
                rule: { required: true, charLength: 320 }
            },
            {
                id: 'other-email',
                label: 'Other Email Addresses(es)',
                type: 'multipleEmail',
                rule: { charLength: 320 },
                labelNote: 'Multiple email addresses can be added with semicolon separation - e.g person@mail.com;person2@mail.com.'
            }
            // {
            //     id: 'nationality',
            //     apiID: 'Nationality',
            //     label: 'Nationality',
            //     type: 'dropdown',
            //     // rules: [
            //     //     {
            //     //         baseField: `${SECT_APPLICANT}-id-type`,
            //     //         ifList: ['NRC'],
            //     //         setValue: () => 'SG',
            //     //         valueIsBased: true
            //     //     }
            //     // ],
            //     rule: {
            //         baseIds: [`${SECT_APPLICANT}-id-type`, `${SECT_TYPE}-applicant-type`],
            //         required: true,
            //         // setValue: ({ baseValues }: RuleProps) => {
            //         //     if (baseValues && baseValues[`${SECT_APPLICANT}-id-type`] === 'NRC') {
            //         //         return 'SG';
            //         //     }
            //         //     return '';
            //         // },
            //         customValidate: ({ currentValue, baseValues }: RuleProps) => {
            //             const idType = baseValues && (baseValues[`${SECT_APPLICANT}-id-type`] as string);
            //             const valid = currentValue === 'SG' && idType === 'NRC';
            //             const validOthers = currentValue !== 'SG' && idType !== 'NRC';
            //             const result = valid || validOthers || 'Invalid Nationality for Selected ID Type';
            //             return result;
            //         },
            //         // disabled: ({ baseValues, isSingpass, myInfoAutoFill }: RuleProps) => {
            //         //     return Boolean(baseValues?.[`${SECT_TYPE}-applicant-type`] === 'Applicant') && isSingpass && myInfoAutoFill;
            //         // }
            //         disabled: ({ myInfoAutoFill }: RuleProps) => {
            //             return myInfoAutoFill;
            //         }
            //     }
            // }
        ]
    },
    {
        sectionID: SECT_ADDRESS,
        sectionName: 'Address Details',
        fieldList: [
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'dropdown',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    charLength: 10
                }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    charLength: 32
                }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M',
                span: 2,
                rule: {
                    charLength: 3,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01',
                span: 2,
                rule: {
                    charLength: 5,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    charLength: 66,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            }
        ]
    }
];

export const COMPANY_FIELDS = [
    {
        sectionID: SECT_APPLICANT,
        sectionName: 'Applicant Details',
        fieldList: [
            {
                id: 'id-type',
                apiID: 'IDTypeFVG',
                label: 'ID Type',
                type: 'dropdown',
                rule: {
                    // baseIds: [`${SECT_APPLICANT}-nationality`, `${SECT_TYPE}-applicant-type`],
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'idno',
                label: 'ID No.',
                type: 'text',
                rule: {
                    // baseIds: [`${SECT_APPLICANT}-id-type`, `${SECT_TYPE}-applicant-type`],
                    required: true,
                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                        const idType = baseValues && (baseValues[`${SECT_APPLICANT}-id-type`] as string);
                        const result = idNoValidation(currentValue as string, idType);
                        return result;
                    },
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'salutaion',
                apiID: 'Salutation',
                label: 'Salutation',
                type: 'dropdown',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                },
                options: [{ optID: 'Dr', optLabel: 'Dr' }]
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text',
                rule: {
                    // baseIds: [`${SECT_TYPE}-applicant-type`],
                    required: true,
                    charLength: 66,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'mobile-no',
                label: 'Contact No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    rule: {
                        baseIds: [`${SECT_APPLICANT}-mobile-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? /^[89][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'other-mobile-no',
                label: 'Other Contact No.',
                type: 'combo',
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    rule: {
                        baseIds: [`${SECT_APPLICANT}-mobile-no-country-code`],
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? /^[689][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'email',
                rule: {
                    required: true,
                    charLength: 320
                }
            },
            {
                id: 'other-email',
                label: 'Other Email Address(es)',
                type: 'multipleEmail',
                rule: { charLength: 320 },
                labelNote: 'Multiple email addresses can be added with semicolon separation - e.g person@mail.com;person2@mail.com.'
            }
            // {
            //     id: 'nationality',
            //     apiID: 'Nationality',
            //     label: 'Nationality',
            //     type: 'dropdown',
            //     // rules: [
            //     //     {
            //     //         baseField: `${SECT_APPLICANT}-id-type`,
            //     //         ifList: ['NRC'],
            //     //         setValue: () => 'SG',
            //     //         valueIsBased: true
            //     //     }
            //     // ],
            //     rule: {
            //         baseIds: [`${SECT_APPLICANT}-id-type`, `${SECT_TYPE}-applicant-type`],
            //         required: true,
            //         // setValue: ({ baseValues }: RuleProps) => {
            //         //     if (baseValues && baseValues[`${SECT_APPLICANT}-id-type`] === 'NRC') {
            //         //         return 'SG';
            //         //     }
            //         //     return '';
            //         // },
            //         customValidate: ({ currentValue, baseValues }: RuleProps) => {
            //             const idType = baseValues && (baseValues[`${SECT_APPLICANT}-id-type`] as string);
            //             const valid = currentValue === 'SG' && idType === 'NRC';
            //             const validOthers = currentValue !== 'SG' && idType !== 'NRC';
            //             const result = valid || validOthers || 'Invalid Nationality for Selected ID Type';
            //             return result;
            //         },
            //         // disabled: ({ baseValues, isSingpass, myInfoAutoFill }: RuleProps) => {
            //         //     return Boolean(baseValues?.[`${SECT_TYPE}-applicant-type`] === 'Applicant') && isSingpass && myInfoAutoFill;
            //         // }
            //         disabled: ({ myInfoAutoFill }: RuleProps) => {
            //             return myInfoAutoFill;
            //         }
            //     }
            // }
        ]
    },
    {
        sectionID: ORGANISATION_DETAILS,
        sectionName: 'Organisation Details',
        fieldList: [
            {
                id: 'organisation-uen-no',
                label: 'UEN No.',
                type: 'text',
                rule: { disabled: true, required: true, charLength: 10 }
            },
            {
                id: 'organisation-name',
                label: 'Organisation Name',
                type: 'text',
                required: true,
                charLength: 50,
                rule: { disabled: true, required: true, charLength: 50 }
            },
            {
                id: 'organisation-mobile-no',
                label: 'Organisation Contact No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    rule: {
                        baseIds: [`${SECT_APPLICANT}-mobile-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? /^[689][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_APPLICANT}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'organisation-email',
                label: 'Organisation Email',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 50,
                    customValidate: ({ currentValue }: RuleProps) => {
                        const emails = currentValue?.toString().replace(/\s/g, '').split(',') || [];
                        const text = 'Please enter a valid email address.';
                        if (emails.length > 0) {
                            const mappedEmail = emails.map((email) => {
                                if (/^[a-zA-Z0-9-._]+@[a-zA-Z0-9-.]+\.[a-zA-Z]*$/.test(email.toString() || '')) {
                                    return true;
                                }
                                return text;
                            });
                            const check = mappedEmail.some((value) => value === text);
                            if (!check) {
                                return true;
                            }
                            return text;
                        }
                        return text;
                    }
                }
            }
        ]
    },
    {
        sectionID: SECT_ADDRESS,
        sectionName: 'Organisation Address Details',
        fieldList: [
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'dropdown',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    charLength: 10
                }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    required: true,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    charLength: 32
                }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M',
                span: 2,
                rule: {
                    charLength: 3,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01',
                span: 2,
                rule: {
                    charLength: 5,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    charLength: 66,
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    }
                }
            }
        ]
    }
];
